var _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditBureau(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "black",
    fillOpacity: 0.12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "#39BAB5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6667 6.99996H14.88C14.6 6.22663 13.8667 5.66663 13 5.66663C12.1333 5.66663 11.4 6.22663 11.12 6.99996H8.33333C7.6 6.99996 7 7.59996 7 8.33329V17.6666C7 18.4 7.6 19 8.33333 19H17.6667C18.4 19 19 18.4 19 17.6666V8.33329C19 7.59996 18.4 6.99996 17.6667 6.99996ZM13 6.99996C13.3667 6.99996 13.6667 7.29996 13.6667 7.66663C13.6667 8.03329 13.3667 8.33329 13 8.33329C12.6333 8.33329 12.3333 8.03329 12.3333 7.66663C12.3333 7.29996 12.6333 6.99996 13 6.99996ZM11.6667 16.3333L9 13.6666L9.94 12.7266L11.6667 14.4466L16.06 10.0533L17 11L11.6667 16.3333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditBureau);
export default __webpack_public_path__ + "static/media/credit-bureau.95cf05cab5761008538c733770e2ce8a.svg";
export { ForwardRef as ReactComponent };